import React from 'react';
import { Header as HeaderStyled } from './Header.styles';
import HeaderWave from './HeaderWave/HeaderWave';
import { HeaderProps } from 'models/HeaderProps';
import { useIntl } from 'react-intl';
import { Formatter } from './Formatter';
import {
  Heading,
  SearchField,
  Navigation
} from '@trustedshops/tps-seo-shared-frontend-react-components';
import { buildHref, mergeShopSearchHrefParams } from 'helpers/buildHref';
import * as Sentry from '@sentry/browser';
import { LocalesAllowedValues } from 'models/Locales';

const Header = ({
  category,
  keyword,
  account,
  activeFilters,
  onParameterChange,
  mobileMenuHandler,
  hideNavigation = false
}: HeaderProps) => {
  const { formatMessage, messages } = useIntl();
  const { headline } = new Formatter(formatMessage, category, keyword, account);
  const translations = messages as LocalesAllowedValues;

  return (
    <>
      {!hideNavigation && (
        <Navigation
          translations={translations}
          mobileMenuHandler={mobileMenuHandler}
          activeFilters={activeFilters}
          activeItemId={'shops'}
          activeSubItemKey={'NAVIGATION.SHOPS'}
          searchPlaceholder={formatMessage({ id: 'SEARCH_PLACEHOLDER_SHORT' })}
          searchBarVisibleFromPx={200}
          hasSearchBar
          legacyBehaviour
          hideLoginLabel
        />
      )}
      <HeaderStyled>
        <Heading as="h1" $lookAlike="h1">
          {headline}
        </Heading>
        <SearchField
          activeFilters={activeFilters}
          onParameterChange={onParameterChange}
          onSearchTermError={
            /* istanbul ignore next */ ({ query, validationMessage }) => {
              if (query && query.length > 1) {
                Sentry.captureException(
                  new Error(
                    `Query "${query}" is invalid. Validation message: "${validationMessage}".`
                  ),
                  { level: 'debug' }
                );
              }
            }
          }
          placeholder={formatMessage({ id: 'SEARCH_PLACEHOLDER' })}
          searchButtonText={formatMessage({ id: 'SEARCH_BUTTON_TEXT' })}
          buildHref={(params) =>
            buildHref(
              mergeShopSearchHrefParams(
                activeFilters,
                params.q ? { ...params, account: undefined } : params
              )
            )
          }
        />
        <HeaderWave />
      </HeaderStyled>
    </>
  );
};

export default Header;
